export default __webpack_public_path__ + "static/SR India - Halal - Certificate-d1f139f36b64b4fcdd120d4fc3944514.pdf";